import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentenceMetaTagsResolver: FieldResolver = (metadata: Metadata) => {
  if (metadata.getMetaTags()) {
    return { sentenceMetaTags: metadata.getMetaTags() } as StreamData
  }

  return {
    sentenceMetaTags: !isEmpty(metadata.getSentenceMetaTags())
      ? (metadata
          .getSentenceMetaTags()!
          .filter((sentenceMetaTag) => !isEmpty(sentenceMetaTag))
          .flatMap((sentenceMetaTag) => sentenceMetaTag) as string[])
      : []
  } as StreamData
}

export default sentenceMetaTagsResolver
